import React from 'react';
import GuestLayout from '@components/layout/Guest';
import { Box, Text, HStack, Button, ButtonGroup, VStack, Link} from "@chakra-ui/react"
import {  ButtonAsset } from "@utils/assets"

class ErrorBoundary extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box className="w-full h-screen bg-black">
            
            <Box className="w-full h-full text-center text-white" bgImage={'url(/bg/auth/1.jpg)'}>

                <Box className="absolute w-full h-full bg-black/25" />

                <VStack spacing={6} className="relative w-full h-full items-center justify-center z-1 container mx-auto">
                    
                    <Box>
                        <Text className="xl:text-8xl text-5xl font-medium mb-3">505 Server Error</Text>
                        <Text>Oops! Something went wrong on our end. Please try again later or contact support.</Text>
                    </Box>

                    <ButtonAsset onClick={() => {
                      return window.location.href = '/'
                    }} buttonProps={{className: '!px-7 !py-4 !text-[15px]'}}>
                      Try Again
                    </ButtonAsset>

                </VStack>

            </Box>

        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
